import { render, staticRenderFns } from "./ProtocolActItemCard.vue?vue&type=template&id=ba63b77e"
import script from "./ProtocolActItemCard.vue?vue&type=script&lang=js"
export * from "./ProtocolActItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports